import { createSlideIcon, type IconProps } from '../SlideTypeIcon';
const DEFAULT_COLOR = 'var(--palette-coral-300)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path d="M17 7H7V9H17V7Z" fill={textColor} />
    <path d="M19 11H5V18H19V11Z" fill={textColor} />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path d="M22.3601 10H9.56006V12.56H22.3601V10Z" fill={textColor} />
    <path d="M24.92 13.5601H7V21.8801H24.92V13.5601Z" fill={textColor} />
  </>
);

export const ParagraphIcon = createSlideIcon(Icon24x24, Icon32x32);
